
    import '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/toast.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-weet-toast-demo-basic","docs-weet-toast-demo-types","docs-weet-toast-demo-closable","docs-weet-toast-demo-update","docs-weet-toast-demo-link","docs-weet-toast-demo-body","docs-weet-toast-demo-provider","docs-weet-toast-demo-panel"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/toast.md?type=demo')
};